import { getNewCommissionMonth } from './getNewCommissionMonth'
import { getListCommissions } from './getListCommissions'
import { postCreateNewMonthlyCommission } from './postCreateNewMonthlyCommission'
import { getPaginatedCommissions } from './getPaginatedCommissions'
import { getCommissionData } from './getCommissionData'
import { getCommissionsState } from './getCommissionsState'
import { updateCommissionMonth } from './updateCommissionMonth'
import { getRangeCommissionMonth } from './getRangeCommissionMonth'
import { getIncentiveCards } from './getIncentiveCards'
import { getPossibleActions } from './getPossibleActions'
import { createComissionPolicy } from './createComissionPolicy'
import { patchCommissionPolicy } from './patchCommissionPolicy'
import { mapPossibleActionToOptions } from './mapPossibleActionToOptions'
import { deleteCommissionPolicy } from './deleteCommissionPolicy'
import { getCommissionsPeriods } from './getCommissionsPeriods'
import { getAllPeriods } from './getAllPeriods'
import { getAvailablePeriods } from './getAvailablePeriods'
import { getPolicy } from './getPolicy'
import { getPolicyById } from './getPolicyById'
import { generateExcel } from './generateExcel'
import { updatePolicyStatus } from './updatePolicyStatus'
import { createPolicyCopy } from './createPolicyCopy'
import { getStock } from './getStock'

export const Commission = {
  getNewCommissionMonth,
  getListCommissions,
  postCreateNewMonthlyCommission,
  getPaginatedCommissions,
  getCommissionData,
  getCommissionsState,
  updateCommissionMonth,
  getRangeCommissionMonth,
  getIncentiveCards,
  getPossibleActions,
  createComissionPolicy,
  patchCommissionPolicy,
  mapPossibleActionToOptions,
  deleteCommissionPolicy,
  getPolicy,
  getPolicyById,  
  getCommissionsPeriods,
  getAllPeriods,
  getAvailablePeriods,
  generateExcel,
  updatePolicyStatus,
  createPolicyCopy,
  getStock
}
